import { take, call, put, race, all, takeEvery, fork, select } from "redux-saga/effects";
import * as Companies from './companyStore';
import { FilterInfo } from "../../common/models/CommonModels";
import { ApplicationState } from "../../store";
import * as api from '../../api/companyApi';

const getFilters = (state: ApplicationState) => state.visibleCompanies.filters;

export function* watchCompaniesSagas(filters?: FilterInfo) {
    const filters2 = yield select(getFilters);

    yield all([
        takeEvery(Companies.ActionType.RequestVisibleCompanies, fetchVisibleCompanies, filters2)
    ])
}

function* fetchVisibleCompanies(filters?: FilterInfo) {
    const filters2 = yield select(getFilters);

    // Fetch companies
    const companies = yield call(api.getVisibleCompanies, filters2);
    if(companies){
        yield put(Companies.actionCreators.receivedVisibleCompanies(companies));
    }
}


// WEBPACK FOOTER //
// ./src/companies/store/sagas.ts